"use client";
import { FeatureLink as Link } from "../../navigation/feature-link";
import type {
  CSSProperties,
  MouseEventHandler,
  PointerEventHandler,
  PropsWithChildren,
} from "react";
import { captureAnalyticsEvent } from "./client";
import type { AnalyticsEventName } from "./events";

type TrackedLinkProps = PropsWithChildren<{
  href: string;
  className?: string;
  style?: CSSProperties;
  analyticsEvent: AnalyticsEventName;
  analyticsProperties?: Record<
    string,
    string | number | boolean | null | undefined
  >;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  onPointerEnter?: PointerEventHandler<HTMLAnchorElement>;
  target?: "_blank" | "_self";
  rel?: string;
  ariaLabel?: string;
}>;

export function TrackedLink({
  href,
  className,
  style,
  analyticsEvent,
  analyticsProperties,
  onClick,
  onPointerEnter,
  target,
  rel,
  ariaLabel,
  children,
}: TrackedLinkProps) {
  return (
    <Link
      href={href}
      className={className}
      style={style}
      target={target}
      rel={rel}
      onPointerEnter={onPointerEnter}
      aria-label={ariaLabel}
      onClick={(event) => {
        captureAnalyticsEvent({
          event: analyticsEvent,
          properties: analyticsProperties,
        });
        onClick?.(event);
      }}
    >
      {children}
    </Link>
  );
}
